import { render, staticRenderFns } from "./EvaluacionRiesgos.vue?vue&type=template&id=cdc78a0e&"
import script from "./EvaluacionRiesgos.vue?vue&type=script&lang=js&"
export * from "./EvaluacionRiesgos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports